/* eslint-disable @typescript-eslint/no-this-alias */
export default {
  getEvents() {
    return {
      "node:click": "onClick",
    };
  },
  calcShouldBegin(ev) {
    const { target } = ev;
    const targetName = target.get("name") || "";
    // FLOW-DOC: nodeBase:node-hover-shape 和 nodeBase:node 都触发 clickNode
    if (
      targetName.startsWith("nodeBase:node") &&
      !this.graph._addingEdge &&
      !this.graph._addingEdgeByClick
    ) {
      return true;
    }

    return false;
  },

  onClick(ev) {
    if (this.calcShouldBegin(ev)) {
      this.graph.emit("xNode:clickNode", ev);
    }
  },
};
